package com.havn.app.core.localization

import kotlinx.browser.window

private const val HavnLanguageKey = "havn.language"

actual fun loadStoredHavnLanguageCode(): String? =
    window.localStorage.getItem(HavnLanguageKey)

actual fun storeHavnLanguageCode(code: String) {
    window.localStorage.setItem(HavnLanguageKey, code)
}
